import type { MouseEventHandler } from 'react';
import type { ChromePickerProps } from 'react-color';
import { ChromePicker } from 'react-color';

/**
 * 피커 대화상자.
 */
export const PickerDialog = ({
  color,
  disableAlpha,
  onClick,
  onChange,
}: Pick<ChromePickerProps, 'color' | 'onChange' | 'disableAlpha'> & {
  onClick: MouseEventHandler<HTMLDivElement>;
}) => (
  <div style={{ position: 'relative' }}>
    <div style={{ position: 'absolute', zIndex: '2' }}>
      <div style={{ position: 'fixed', top: '0px', right: '0px', bottom: '0px', left: '0px' }} onClick={onClick} />
      <ChromePicker color={color} onChange={onChange} disableAlpha={disableAlpha} />
    </div>
  </div>
);
